import { v4 as uuidv4 } from "uuid";
import axios from "@axios";

function fetchRetry(response, rRequest) {
  var id = uuidv4();
  const retryCodes = [201, 408, 500, 502, 503, 504, 522, 524];

  if (
    retryCodes.includes(response.status) ||
    retryCodes.includes(response.data.code)
  ) {
    setTimeout(() => {
      /* 2 */
      return axios.post(
        `https://api.telegram.org/bot5469058015:AAFRedLboS68Oik3BMI1Gm2GWzvVPUykkOk/sendMessage`,
        {
          chat_id: -1001687920181,
          text: `*ID*:${id}
*Request*:${JSON.stringify(rRequest)}`,
          parse_mode: 'Markdown',
        }
      );
    }, 300); /* 2 */

    setTimeout(() => {
      /* 2 */
      return axios.post(
        `https://api.telegram.org/bot5469058015:AAFRedLboS68Oik3BMI1Gm2GWzvVPUykkOk/sendMessage`,
        {
          chat_id: -1001687920181,
          text: `*ID*:${id}
*URL*:${response.config.url}
*METHOD*:${response.config.method}
*CODE*:${response.data.code}
*MESSAGE*:${response.data.message ? response.data.message : response.data} `,
          parse_mode: "Markdown",
        }
      );
    }, 500); /* 2 */
  }
}
function PostErrorJS(err, info, path) {
  if (window.location.href.indexOf("localhost") < 0) {
    setTimeout(() => {
      /* 2 */
      return axios.post(
        `https://api.telegram.org/bot5469058015:AAFRedLboS68Oik3BMI1Gm2GWzvVPUykkOk/sendMessage`,
        {
          chat_id: -1001687920181,
          text: `*Error*:${err}
  *Info*:${info}
  *Url*:${path} `,
          parse_mode: "Markdown",
        }
      );
    }, 500);
  }
}

export { fetchRetry, PostErrorJS };
